import Aladin from "../images/Aladin.png";
import Jasmin from "../images/Jasmin.png";
import Sultan from "../images/Sultan.png";
import Jafar from "../images/Jafar.png";
import Admin from "../images/Admin.png";
import chatbot from "../images/chatbot.png";

export const Projects = [
  {
    image: Sultan,
    name: "Sultan",
    text: "B2B - B2C",
  },
  {
    image: chatbot,
    name: "ChatBot",
    text: "AI-Powered Chatbot Orchestrator",
  },

  {
    image: Jasmin,
    name: "Jasmin",
    text: "Back Office service management",
  },
  {
    image: Aladin,
    name: "Aladin",
    text: "Parking Business logic",
  },
  {
    image: Jafar,
    name: "Jafar",
    text: "PMS & Hardware management",
  },
  {
    image: Admin,
    name: "Admin",
    text: "",
  },
];
